import { Segmented } from "antd";
import { EyeOutlined, SettingOutlined } from "@ant-design/icons";
import COLORS from "common/Colors";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { getMenuList, getUserRoleId } from "redux/selectors";
import KpiPlanningList from "./KpiPlanningList";
import AppraisalList from "./AppraisalList";
import KpiViewModal from "./KpiViewModal";
import WeightageSettingsModal, {
  DEFAULT_SCORE_WEIGHTAGE,
  fetchScoreWeightage,
} from "./WeightageSettingsModal";

const PerformanceKpiManagementWrap = styled.div`
  .ant-segmented {
    background: #f5f5f5;
    border-radius: 20px;
    padding: 4px;
    margin: 16px 0;
  }
  .ant-segmented-item {
    border-radius: 16px;
    font-weight: 500;
    font-size: 15px;
    color: ${COLORS.TEXT.PRIMARY};
    padding: 4px 8px;
  }
  .ant-segmented-item-selected {
    background: #e3e8fc;
    color: ${COLORS.TAB};
    font-weight: 600;
  }
  .header-divider {
    display: inline-block;
    width: 1px;
    height: 16px;
    background: #d9d9d9;
  }
`;

const PerformanceKpiManagement = () => {
  const history = useHistory();
  const location = useLocation();
  const [tabId, setTabId] = useState(location.state?.id || "kpiplanning");
  const [kpiViewOpen, setKpiViewOpen] = useState(false);
  const [settingsOpen, setSettingsOpen] = useState(false);
  // Technical vs Soft Skills split for the appraisal Overall Average - read
  // once here and shared with Appraisal > My Team.
  const [scoreWeightage, setScoreWeightage] = useState(DEFAULT_SCORE_WEIGHTAGE);
  const menuList = useSelector(getMenuList);
  const userRoleId = useSelector(getUserRoleId);

  useEffect(() => {
    if (location.state?.id) setTabId(location.state.id);
  }, [location.state]);

  useEffect(() => {
    fetchScoreWeightage().then(setScoreWeightage);
  }, []);

  // Both entries share key "hrperformance" - only menuName tells the
  // company-level "KPI" preview apart from the "Company & Departmental KPIs"
  // management page, so each header link is gated on its own menuName.
  const Menulist = menuList[userRoleId] || Object.values(menuList)[0] || menuList;
  const canViewKpi = true
  // Menulist?.find(
  //   (item) => item?.menuName === "Performance - KPI" && item?.permission?.view
  // );
  const canViewDepartmentKpi = true
  // Menulist?.find(
  //   (item) => item?.menuName === "Performance - Department KPI" && item?.permission?.view
  // );
  // "Score Weightage Settings" has its own Roles & Permissions entry: view
  // shows the header link, edit/create allows saving a new split.
  const weightageMenu = Menulist?.find?.((item) => item?.key === "scoreweightagesettings");
  const canViewSettings = Boolean(weightageMenu?.permission?.view);
  const canEditSettings = Boolean(
    weightageMenu?.permission?.edit || weightageMenu?.permission?.create
  );

  const options = [
    { label: "KPI Planning", value: "kpiplanning" },
    { label: "Appraisal", value: "appraisal" },
  ];

  return (
    <PerformanceKpiManagementWrap>
      <div className="d-flex justify-content-between align-items-center">
        <h6>Performance Management – Balanced Score Card</h6>
        {(canViewKpi || canViewDepartmentKpi || canViewSettings)  &&(
        <div className="d-flex align-items-center gap-3">
          {canViewKpi &&(
<>
<span style={{ cursor: "pointer", color: COLORS.PRIMARY }} onClick={() => setKpiViewOpen(true)}>
  <EyeOutlined /> Company KPI
</span>
<span className="header-divider" />
</>
          )}
          {canViewSettings && (
<>
<span style={{ cursor: "pointer", color: COLORS.PRIMARY }} onClick={() => setSettingsOpen(true)}>
  <SettingOutlined /> Settings
</span>
<span className="header-divider" />
</>
          )}
          {canViewDepartmentKpi && (

          <span
            className="lite-text"
            style={{ cursor: "pointer", color: COLORS.PRIMARY }}
            onClick={() => history.push("/performance-kpi-company-department")}
          >
            Company & Departmental KPIs
          </span>
          )}
        </div>)}
      </div>
      <Segmented value={tabId} onChange={setTabId} options={options} />
      {tabId === "kpiplanning" ? (
        <KpiPlanningList />
      ) : (
        <AppraisalList scoreWeightage={scoreWeightage} />
      )}

      <KpiViewModal open={kpiViewOpen} onClose={() => setKpiViewOpen(false)} />
      <WeightageSettingsModal
        open={settingsOpen}
        onClose={() => setSettingsOpen(false)}
        weightage={scoreWeightage}
        onSaved={setScoreWeightage}
        canEdit={canEditSettings}
      />
    </PerformanceKpiManagementWrap>
  );
};

export default PerformanceKpiManagement;
